export default __webpack_public_path__ + "static/media/logo_frontapp.e6a0b972.svg";